import { useState } from "react";
import { CustosFixosInputCard } from "./components/CustosFixosInputCard";
import { CustosFixosResponse } from "./components/CustosFixosResponse";
import type { ResultsType } from "./calculadora-custos-fixos_d";

export default function CustosFixos() {
  const [results, setResults] = useState<ResultsType | null>(null);

  return (
    <>
      <CustosFixosInputCard setResults={setResults} />
      {results && <CustosFixosResponse results={results} />}
    </>
  );
}